var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RampType } from '../constants/index.js';
import { ITransDirectEnum, } from '../types/index.js';
import { stringifyUrl } from 'query-string';
import { validateError } from '../utils/index.js';
export class RampProvider {
    constructor(options) {
        this.providerInfo = options.providerInfo;
        this.service = options.service;
    }
    getOrderId(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, message, success, code } = yield this.service.getOrderNo(params);
            validateError(message, success, code);
            return data.orderId;
        });
    }
}
export class AlchemyPayProvider extends RampProvider {
    constructor(options) {
        super(options);
        this.providerInfo = options.providerInfo;
        this.service = options.service;
    }
    createOrder(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { baseUrl, appId, key, callbackUrl } = this.providerInfo;
            const { type, network, country, fiat, crypto, amount, address, email, withdrawUrl, clientId, networkType } = params;
            let handleOrderUrl = `${baseUrl}/?type=${type.toLocaleLowerCase()}&crypto=${crypto}&network=${network}&country=${country}&fiat=${fiat}&appId=${appId}&callbackUrl=${encodeURIComponent(`${callbackUrl}`)}`;
            const orderId = yield this.getOrderId({
                transDirect: type === RampType.BUY ? ITransDirectEnum.TOKEN_BUY : ITransDirectEnum.TOKEN_SELL,
                merchantName: key,
            });
            if (orderId)
                handleOrderUrl += `&merchantOrderNo=${orderId}`;
            if (withdrawUrl) {
                const withdrawUrlTrans = encodeURIComponent(withdrawUrl +
                    `&payload=${encodeURIComponent(JSON.stringify({ orderNo: orderId }))}&networkType=${networkType}&clientId=${clientId}`);
                handleOrderUrl += `&withdrawUrl=${withdrawUrlTrans}`;
            }
            if (type === RampType.BUY) {
                handleOrderUrl += `&fiatAmount=${amount}`;
                if (email) {
                    const achTokenInfo = yield this.getToken(email);
                    if (achTokenInfo !== undefined) {
                        handleOrderUrl += `&token=${encodeURIComponent(achTokenInfo.accessToken)}`;
                    }
                }
                const signature = yield this.getSignature(address);
                handleOrderUrl += `&address=${address}&sign=${encodeURIComponent(signature)}`;
            }
            else {
                handleOrderUrl += `&cryptoAmount=${amount}&source=3#/sell-formUserInfo`;
            }
            return { orderId, url: handleOrderUrl };
        });
    }
    getToken(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, success, code, message } = yield this.service.getAchPayToken({ email });
            validateError(message, success, code);
            return data;
        });
    }
    getSignature(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, success, code, message } = yield this.service.getAchPaySignature({ address });
            validateError(message, success, code);
            return data.signature;
        });
    }
}
export class TransakProvider extends RampProvider {
    constructor(options) {
        super(options);
        this.providerInfo = options.providerInfo;
        this.service = options.service;
    }
    createOrder(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { baseUrl, appId, key } = this.providerInfo;
            const { type, network, country, fiat, crypto, amount, address, email, withdrawUrl } = params;
            const orderId = yield this.getOrderId({
                transDirect: type === RampType.BUY ? ITransDirectEnum.TOKEN_BUY : ITransDirectEnum.TOKEN_SELL,
                merchantName: key,
            });
            if (params.type === RampType.BUY) {
                const handleOrderUrl = stringifyUrl({
                    url: baseUrl,
                    query: {
                        apiKey: appId,
                        productsAvailed: type,
                        fiatAmount: amount,
                        fiatCurrency: fiat,
                        countryCode: country,
                        network: network,
                        cryptoCurrencyCode: crypto,
                        walletAddress: address,
                        email: email,
                        partnerOrderId: orderId,
                        redirectURL: withdrawUrl,
                    },
                }, { encode: true });
                return { orderId, url: handleOrderUrl };
            }
            // TODO sell
            return { orderId, url: '' };
        });
    }
}
